import { useSelector } from 'react-redux';

import { useZappieChipLang } from './useZappieChipLang';
import ordersSelector from 'redux/selectors/orders-selectors/orders.selectors';

export function useZappieChip() {
  const orderDetail = useSelector(
    ordersSelector.selectOrderDetailInOrderDetailDialog,
  );

  const isRender = orderDetail?.special_order?.includes('zappie') ?? false;

  const lang = useZappieChipLang();

  return {
    lang,
    isRender,
  };
}
